const formatMoney = (value: number) => {
    if (!value) return "R$ 0,00"
    const numero = value.toFixed(2).split('.');
    numero[0] = "R$ " + numero[0].split(/(?=(?:...)*$)/).join('.');
    return numero.join(',');
}

export default formatMoney;